import React, { useEffect, useMemo, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { getUserHierarchy } from '../../utils/mainServices';
import { getUserId } from '../../shared/utils/SharedAuthentication';

const Hierarchy = ({ onClose, userId }) => {
  const [loading, setLoading] = useState(true);
  const [hier, setHier] = useState(null);
  const [error, setError] = useState('');
  const getter = getUserId();

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await getUserHierarchy(getter, userId);
        if (mounted) setHier(res?.content || null);
      } catch (e) {
        if (mounted) setError('Failed to load hierarchy');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [getter, userId]);

  const nodes = useMemo(() => {
    if (!hier) return [];
    const list = [];
    if (hier.accountName) list.push({ key: 'account', label: hier.accountName });
    if (hier.corporateName) list.push({ key: 'corporate', label: hier.corporateName });
    if (hier.farmName) list.push({ key: 'farm', label: hier.farmName });
    return list;
  }, [hier]);

  const levelText = (hier?.userLevel || '').replace(/_/g, ' ').toUpperCase();

  return (
    <div className={"sa-popup-bg "}>
      <div className="sa-popup">
        <div className={"sa-modal-box-style"}>
          <div className="sa-popup-header">
            <span className={"sa-model-heading"}>User Hierarchy</span>
            <div className="sa-popup-close-icon" onClick={() => onClose(false)}>
              <FeatherIcon className={"sa-modal-close-icon"} icon={"x"} />
            </div>
          </div>

          <div className="sa-popup-content" style={{marginLeft: "16px"}}>
            {!loading && !error && hier && (
              <div className="umsh-root">
                <div className="umsh-toprow">
                  <div className="umsh-col">
                    <div className="umsh-field-label">User Name</div>
                    <div className="umsh-field-value">{hier.userName || '-'}</div>
                  </div>

                  <div className="umsh-col">
                    <div className="umsh-field-label">User Level</div>
                    <div className="umsh-field-value">{levelText}</div>
                  </div>
                </div>

                <div>
                  <div className="umsh-hierarchy-title">Hierarchy</div>
                  {nodes.length === 0 ? (
                    <div>No hierarchy found</div>
                  ) : (
                    <div className="umsh-nodes">
                      {nodes.map((n, idx) => (
                        <div key={n.key + idx} className={`umsh-node hier-level-${idx}`}>
                          {idx > 0 && <span className="umsh-connector" />}
                          <div className="umsh-node-label">{n.label}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hierarchy;